import {useFocus} from 'focus-manager/web';
import * as React from 'react';

interface IButtonProps extends React.PropsWithChildren {
    anchors?: number[];
    basis?: number;
    children: React.ReactNode;
    disableFocus?: boolean;
    isUpperCased?: boolean;
    onSelect?: () => void;
}

const Button: React.FC<IButtonProps> = ({anchors, basis, children, disableFocus, isUpperCased, onSelect}) => {
    const {setFocusableElementRef} = useFocus({
        disableFocus,
        focusableBasis: basis,
        focusableAnchors: anchors,
        onSelect,
    });

    const className = ['key', 'key--button', basis && `key--basis-${basis}`, isUpperCased && `key--uppercased`]
        .filter(Boolean)
        .join(' ');

    return (
        <button type="button" disabled={disableFocus} ref={setFocusableElementRef} className={className}>
            {children}
        </button>
    );
};

export default React.memo(Button);
